import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { ObjetosService } from 'src/app/core/http/apiProducto/objetos.service';
import { IPantalla } from 'src/app/core/interfaces/response/IGetPantallasResponse';
import { MsalAccountService } from 'src/app/core/services/msal-account/msal-account.service';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { IPartner, IUser } from 'src/app/state/user/user.models';
import { selectUser } from 'src/app/state/user/user.selectors';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  headerConfiguration: HeaderConfiguration = {
    layoutAlign: 'start start',
    sections: [
    {
      partner:true,
      menu:true,
    }
    ],
  };

  userForm: FormGroup;

  user: any
  option: string;
  phone: string;
  whatsApp: string;
  ingoodEmail: string;
  dropdowns: IPantalla[] = [];
  isAdmin: any;

  constructor(
    private objetosService: ObjetosService,
    private store: Store,
    private authService: MsalService,
    private msalAccountService: MsalAccountService
  ) {
    this.userForm = new FormGroup({
      name: new FormControl(''),
      surname: new FormControl(''),
      email: new FormControl(''),
    })
   }

  ngOnInit() {
    
    this.getRole()
    this.loadContactInfo();
    this.loadUser();
    this.option = 'userData';
    this.loadDropdowns();
  }

  loadUser(){
    this.store.select(selectUser).pipe(first()).subscribe((res: any) => {
      this.user = res;
      this.userForm.patchValue({
        name: this.user?.name?.substring(0, this.user.name.indexOf(" ")),
        surname: this.user?.name?.substring(this.user.name.indexOf(" ") + 1),
        email: this.user?.username
      })
    })
      
  }

  loadContactInfo(){
    this.phone = environment.helpContactInfo.phone
    this.whatsApp = environment.helpContactInfo.whatsApp
    this.ingoodEmail = environment.helpContactInfo.email
  }

  loadDropdowns(){
    this.objetosService.getCoverageInfoText('perfilUsuario', 1050).pipe(first()).subscribe(resp => {
      resp.data.forEach(element => {
        this.dropdowns.push({title: element.aliasPantallaSeccion, descripcion: element.descPantallaSeccion});
      });
    })
  }

  selectTab(tabName: string){
    this.option = tabName;
  }

  getRole(){
    const account = this.msalAccountService.getAccountInfo();
    let authData = JSON.parse(JSON.stringify(account.idTokenClaims))
    this.isAdmin = authData.roles.some(role => role.includes('Administrator'))
  }

  logout() {
    this.authService.logoutRedirect({
      postLogoutRedirectUri: environment.baseUrlRedirect
    });
  }

  ngOnDestroy(): void {

  }
}